import './customcursor.scss';

const CustomCursor = () => {
  return (
    <>
      {/* <div className="cs-cursor_lg" ref={cursorLg}></div>
      <div className="cs-cursor_sm" ref={cursorSm}></div> */}
    </>
  );
};

export default CustomCursor;
